var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResidentPasswordSetSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 25.0586C1.5 28.2103 2.12078 31.3312 3.32689 34.243C4.533 37.1548 6.30083 39.8005 8.52944 42.0292C10.758 44.2578 13.4038 46.0256 16.3156 47.2317C19.2274 48.4378 22.3483 49.0586 25.5 49.0586C28.6517 49.0586 31.7726 48.4378 34.6844 47.2317C37.5962 46.0256 40.242 44.2578 42.4706 42.0292C44.6992 39.8005 46.467 37.1548 47.6731 34.243C48.8792 31.3312 49.5 28.2103 49.5 25.0586C49.5 21.9069 48.8792 18.786 47.6731 15.8742C46.467 12.9624 44.6992 10.3166 42.4706 8.08803C40.242 5.85943 37.5962 4.0916 34.6844 2.88549C31.7726 1.67937 28.6517 1.05859 25.5 1.05859C22.3483 1.05859 19.2274 1.67937 16.3156 2.88549C13.4038 4.0916 10.758 5.85943 8.52944 8.08803C6.30083 10.3166 4.533 12.9624 3.32689 15.8742C2.12078 18.786 1.5 21.9069 1.5 25.0586Z",
    fill: "#16C270",
    stroke: "#16C270",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.5586L23 33.0586L35 20.0586",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentPasswordSetSuccess);
export default __webpack_public_path__ + "static/media/resident-password-set-success.1ba85411f5d6405b40269240ff893f80.svg";
export { ForwardRef as ReactComponent };